import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const IrradianceOnlyComparisonChart = () => {
  const [month, setMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const plants = ["SLS", "Sweelee"];

  useEffect(() => {
    const fetchIrradianceData = async () => {
      setLoading(true);
      try {
        // Fetch both plants' data in parallel
        const [resSLS, resSweelee] = await Promise.all([
          axios.post("/api/dailyirradcompare", { plant: "SLS", month }),
          axios.post("/api/dailyirradcompare", { plant: "Sweelee", month }),
        ]);

      
        const slsData = resSLS.data || [];
        const sweeleeData = resSweelee.data || [];

        if (slsData.length === 0 && sweeleeData.length === 0) {
          setChartData([]);
          setLoading(false);
          return;
        }

        const earliestDateStr =
          slsData.length > 0
            ? slsData[0]["date"]
            : sweeleeData[0]["dailyIrrad"];
        const earliestDate = new Date(earliestDateStr);

       
        const filterByStartDate = (data) =>
          data.filter(
            (item) => new Date(item["date"]) >= earliestDate
          );

        const filteredSLS = filterByStartDate(slsData);
        const filteredSweelee = filterByStartDate(sweeleeData);
         
      
        // const sweeleeMap = new Map();
        // filteredSweelee.forEach((item) =>
        //   sweeleeMap.set(item["date"], item["dailyIrrad"])
        // );

        // const mergedData = filteredSLS.map((item) => {
        //   const date = item["date"];
        //   return {
        //     date,
        //     SLS: item["dailyIrrad"],
        //     Sweelee: sweeleeMap.get(date) ?? 0,
        //   };
        // });
        const slsMap = new Map(filteredSLS.map(item => [item.date, item.dailyIrrad]));
       const sweeleeMap = new Map(filteredSweelee.map(item => [item.date, item.dailyIrrad]));

const commonDates = [...slsMap.keys()].filter(date => sweeleeMap.has(date));

const mergedData = commonDates.map(date => ({
  date,
  SLS: slsMap.get(date),
  Sweelee: sweeleeMap.get(date)
}));


        

        setChartData(mergedData);
      } catch (error) {
        console.error("Error fetching irradiance data:", error);
        setChartData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchIrradianceData();
  }, [month]);

  return (
    <div style={{ padding: "20px",backgroundColor:"white"}}>
      <h6 className="text-lg font-bold mb-4">
        Daily Irradiance (kWh/m²) Comparison of Sweelee Huawei and Trek Datalogger —{" "}
        {new Date(month).toLocaleString("default", {
          month: "long",
          year: "numeric",
        })}
      </h6>

      <input
        type="month"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        style={{
          marginBottom: "20px",
          padding: "8px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontWeight: "bold",
          width: "150px",
        }}
      />

      {loading ? (
        <p>Loading chart...</p>
      ) : chartData.length === 0 ? (
        <p>No data available for this month.</p>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              angle={-45}
              textAnchor="end"
              height={60}
              tickFormatter={(str) =>
                new Date(str).toLocaleDateString(undefined, { day: "numeric" })
              }
              label={{
             
                value: `Day of Month (${new Date(month).toLocaleString('default', { month: 'long' })})`,
                position: "insideBottomRight",
                offset: -5,
              }}
            />
            <YAxis
              label={{
                value: " DailyIrradiance (kWh/m²)",
                angle: -90,
                position: "insideLeft",
              }}
              domain={[0, "auto"]}
            />
            <Tooltip
  labelFormatter={(label) =>
    `Date: ${new Date(label).toLocaleDateString('en-GB')}`
  }
  formatter={(value) => value.toFixed(2)}
/>

            <Legend verticalAlign="top" />
            <Line
              type="monotone"
              dataKey="SLS"
              stroke="#2980b9"
              name="TrekSecureDatalogger"
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="Sweelee"
              stroke="#c0392b"
              name="HuaweiDatalogger"
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default IrradianceOnlyComparisonChart;
